<template>
    <div class="home-offer-comparator">
      <table>
        <!-- Table Headers -->
        <tr>
          <th>House Buying Factors</th>
          
          <th v-for="home in homeOffers" :key="home.id">Your Perceived Value </th>
        </tr>
  
        <!-- Base Salary Row -->
        <tr>
          <td>Base City Value:</td>
          <td v-for="home in homeOffers" :key="home.id">
            <input v-model.number="home.baseCityValue" type="number" placeholder="$" />
          </td>
        </tr>
      <!-- Subheader for Location Factors -->
      <tr>
          <th colspan="100%">Location Factors</th>
        </tr>
  
        <!-- Dynamic Home Components -->
        <tr v-for="(comp, index) in locationComponents" :key="index">
          <td>{{ comp.label }}</td>
          <td v-for="home in homeOffers" :key="home.id">
            <input v-model.number="home[comp.prop]" type="number" :placeholder="comp.placeholder" />
          </td>
        </tr>
  
            <!-- Subheader for Location Factors -->
      <tr>
          <th colspan="100%">Home Components</th>
        </tr>
        <!-- Location Factors Rows -->
  
        <tr v-for="(comp, index) in homeComponents" :key="index">
          <td>{{ comp.label }}</td>
          <td v-for="home in homeOffers" :key="home.id">
            <input v-model.number="home[comp.prop]" type="number" :placeholder="comp.placeholder" />
          </td>
        </tr>
  
  
                 <!-- Subheader for Location Factors -->
      <tr>
          <th colspan="100%">Interior Components</th>
        </tr>
  
        <tr v-for="(comp, index) in interiorComponents" :key="index">
          <td>{{ comp.label }}</td>
          <td v-for="home in homeOffers" :key="home.id">
            <input v-model.number="home[comp.prop]" type="number" :placeholder="comp.placeholder" />
          </td>
        </tr>
    
         
         
         
  
   
         
         
         
          <!-- Happiness Components for Each home -->
          <tr>
          <th>Minimum Happiness Value:</th>
          <th v-for="home in homeOffers" :key="home.id">Your Ideal Home</th>
        </tr>
  
        <!-- Loop through each happiness component -->
        <tr v-for="component in happinessComponents" :key="component.label">
          <td>{{ component.label }}</td>
          <td v-for="home in homeOffers" :key="home.id">
            <input type="range" v-model="home.happiness[component.label]" min="1" max="10" class="slider">
            <span>{{ home.happiness[component.label] }}</span>
          </td>
        </tr>
  
        <!-- Total Happiness Score Row -->
     
  
      
     
          <th colspan="100%">Your Maximum Pricing Preferences</th>
      
  
        <tr v-for="(comp, index) in UserPriceComponents" :key="index">
          <td>{{ comp.label }}</td>
          <td v-for="home in homeOffers" :key="home.id">
            <input v-model.number="home[comp.prop]" type="number" :placeholder="comp.placeholder" />
          </td></tr>  
  
      </table>
      <button @click="addhomeOffer">Add home Offer</button>
    </div>
  
  
  
   <br><br><br><br><br><br>
  </template>
  
  <script>
  import { ref, reactive, watch } from 'vue';
  
  export default {
    setup() {
      const homeOffers = reactive([
        { id: '1', baseCityValue: 400000, location1: 180000, location2: 200000, location3: 50000, location4: 60000, location5: 250000, location6: 60000, location7: 70000, location8: 90000, location9: 100000,  location10: 120000, housedetail1: 0, housedetail2: 0, housedetail3:0, housedetail4:0, housedetail5:0, housedetail6:0, housedetail7:0, housedetail8:0, housedetail9:0, housedetail10:0, housedetail11:0, housedetail12:0,housedetail13:0,housedetail14:0, housedetail15:0,interior1: 0, interior2: 0, interior3:0, interior4:0, interior5:0, interior6:0, interior7:0, interior8:0, interior9:0, interior10:0,interior11:0, interior12:0, interior13:0, interior14:0, interior15:0, pricing1: 0, pricing2:0, pricing3:0, pricing4:0, pricing5:0, applyFactor1: false, applyfactor2: false, happiness: { 'Commute time': 0, 'Travel Required': 0, 'Learning and Development': 0, 'Career Progression': 0, 'Company Reputation': 0, 'Commitment to DEI': 0, 'home Stability': 0, 'home Stress Level': 0, 'Leadership style of Direct Manager': 0, 'Gut Feeling': 0 }},
      
     
      ]);
  
      const locationComponents = ref([
        { label: 'Queen West:', prop: 'location1', placeholder: '$' },
        { label: 'King West:', prop: 'location2', placeholder: '$' },
        { label: 'Junction:', prop: 'location3', placeholder: '$' },
        { label: 'Leslieville:', prop: 'location4', placeholder: '$' },
        { label: 'Yorkville:', prop: 'location5', placeholder: '$' },
        { label: 'East York:', prop: 'location6', placeholder: '$' },
        { label: 'Scarborough:', prop: 'location7', placeholder: '$' },
        { label: 'Etobicoke:', prop: 'location8', placeholder: '$' },
        { label: 'Markham:', prop: 'location9', placeholder: '$' },
        { label: 'North York:', prop: 'location10', placeholder: '$' },
     
        ]);
        const homeComponents = ref([
        { label: 'Two-Storey:', prop: 'housedetail1', placeholder: '$' },
        { label: 'Split Level:', prop: 'housedetail2', placeholder: '$' },
        { label: 'Bungalow:', prop: 'housedetail3', placeholder: '$' },
        { label: 'Townhouse:', prop: 'housedetail4', placeholder: '$' },
      { label: 'Three Bedroom:', prop: 'housedetail5', placeholder: '$' },
        { label: 'Two Bedroom + Office:', prop: 'housedetail6', placeholder: '$' },
        { label: 'Additional Bedrooms:', prop: 'housedetail7', placeholder: '$' },
        { label: 'Two+ Bathrooms', prop: 'housedetail8', placeholder: '$' },
        { label: 'CN Tower View/Great View', prop: 'housedetail9', placeholder: '$' },
        { label: 'Finished Basement:', prop: 'housedetail10', placeholder: '$' },
        { label: 'Double Car Garage', prop: 'housedetail11', placeholder: '$' },
        { label: 'Single Car Garage:', prop: 'housedetail2', placeholder: '$' },
        { label: 'Solarium:', prop: 'housedetail13', placeholder: '$' },
        { label: 'Gas available on site:', prop: 'housedetail14', placeholder: '$' },
        { label: 'Gym/Spa/Sauna:', prop: 'housedetail15', placeholder: '$' },
    
        
  
      ]);
  
      const interiorComponents = ref([
      { label: 'Dark Hardwood Floors:', prop: 'interior1', placeholder: '$' },
        { label: 'Kitchen Layout - L shaped/small:', prop: 'interior2', placeholder: '$' },
        { label: 'Kitchen Layout - Large and Beautiful', prop: 'interior3', placeholder: '$' },
        { label: 'Wall Oven', prop: 'interior4', placeholder: '$' },
        { label: 'Granite Counters', prop: 'interior5', placeholder: '$' },
        { label: 'Quartz Counters:', prop: 'interior6', placeholder: '$' },
        { label: 'Kitchen Island', prop: 'interior7', placeholder: '$' },
        { label: 'Kitchen Pantry', prop: 'interior8', placeholder: '$' },
        { label: 'Open Concept Living', prop: 'interior9', placeholder: '$' },
        { label: 'Large Foyer', prop: 'interior10', placeholder: '$' },
        { label: '10+ feet ceilings:', prop: 'interior11', placeholder: '$' },
        { label: 'Vaulted/Cathedral Ceiling:', prop: 'interior12', placeholder: '$' },
        { label: 'Carpet Throughout', prop: 'interior13', placeholder: '$' },
        { label: 'House Previously Flooded', prop: 'interior14', placeholder: '$' },
        { label: 'Major Renovations Required (value perspective)', prop: 'interior15', placeholder: '$' },
     
        ]);
  
  
  
        const UserPriceComponents = ref([
        { label: 'Maximum Purchase Budget for home', prop: 'userpricing1', placeholder: '$' },
        { label: 'Minimum Square Footage (Lot):', prop: 'userpricing2', placeholder: '$' },
        { label: 'Minimum Square Footage (House)', prop: 'userpricing3', placeholder: '$' },
        { label: 'Maximum Energy Costs per Year:', prop: 'userpricing4', placeholder: '$' },
        { label: 'Maximum Utility Costs per Year', prop: 'userpricing5', placeholder: '$' },
        { label: 'Maximum Property Taxes per Year', prop: 'userpricing6', placeholder: '$' },
        { label: 'Maximum Maintenance Fees per Year', prop: 'userpricing7', placeholder: '$' },
  
     
        //]);
        //const pricingComponents = ref([
        //{ label: 'Asking Price:', prop: 'pricing1', placeholder: '$' },
        //{ label: 'Square Footage (Lot):', prop: 'pricing2', placeholder: '$' },
        //{ label: 'Square Footage (House)', prop: 'pricing3', placeholder: '$' },
        //{ label: 'Energy Costs per Year:', prop: 'pricing4', placeholder: '$' },
        //{ label: 'Utility Costs per Year', prop: 'pricing5', placeholder: '$' },
        //{ label: 'Property Taxes per Year', prop: 'pricing6', placeholder: '$' },
        //{ label: 'Approximate Maintenance Fees per Year', prop: 'pricing7', placeholder: '$' },
  
     
        ]);
  
        
  
  
      const happinessComponents = ref([
        { label: 'Overall Condition of House', value: 3 },
        { label: 'Great Schools nearby', value: 3 },
        { label: 'Home Layout', value: 3 },
        { label: 'Wow Factor', value: 3 },
        { label: 'Closet Space', value: 3 },
        { label: 'Location to Amenities', value: 3 },
        { label: 'Resale Value', value: 3 },
        { label: 'Mobile Signal Strength', value: 3 },
        { label: 'Curb Appeal', value: 3 },
        { label: 'Natural Light', value: 3 },
        { label: 'Entertaining Space', value: 3 },
        { label: 'High Speed Internet available', value: 3 },
  
  
        ]);
        
    const userPreferences = reactive({
      baseCityValue: 0,
      locationFactors: {},
      homeFactors: {},
      interiorFactors: {},
      pricingFactors: {},
    // Add other factors as needed
  });
  
  
  const loadPreferences = () => {
    const savedPreferences = localStorage.getItem('userPreferences');
    if (savedPreferences) {
      Object.assign(userPreferences, JSON.parse(savedPreferences));
    }
  };
  
  // Watch for changes in userPreferences and save them to local storage
  watch(userPreferences, (newVal) => {
    localStorage.setItem('userPreferences', JSON.stringify(newVal));
  }, { deep: true });
  
  // Call loadPreferences in setup to initialize the data
  loadPreferences();
        // ... add other components
  
      function addhomeOffer() {
    const newId = String.fromCharCode(homeOffers[homeOffers.length - 1].id.charCodeAt(0) + 1);
    homeOffers.push({ 
      id: newId, 
      baseCityValue: 0, 
      location1: 0, 
      location2: 0, 
      location3: 0, 
      location4: 0, 
      location5: 0, 
      location6: 0, 
      location7: 0, 
      location8: 0, 
      location9: 0, 
      location10: 0, 
      housedetail1: 0, 
      housedetail2: 0, 
      housedetail3: 0, 
      housedetail4: 0, 
      housedetail5: 0, 
      housedetail6: 0, 
      housedetail7: 0, 
      housedetail8: 0, 
      housedetail9: 0, 
      housedetail10: 0, 
      housedetail11: 0, 
      housedetail12: 0, 
      housedetail13: 0, 
      housedetail14: 0, 
      housedetail15: 0, 
      interior1: 0, 
      interior2: 0, 
      interior3: 0, 
      interior4: 0, 
      interior5: 0, 
      interior6: 0, 
      interior7: 0, 
      interior8: 0, 
      interior9: 0, 
      interior10: 0, 
      interior11: 0, 
      interior12: 0, 
      interior13: 0, 
      interior14: 0, 
      interior15: 0, 
      happiness: {
        'Overall Appearance of House': 0, 
        'Condition': 0, 
        'Layout': 0, 
        'Wow Factor': 0, 
        'Closet Space': 0, 
        'Location to Amenities': 0, 
        'cell phone signal': 0, 
        'Curb Appeal': 0, 
        'Natural Light': 0, 
        'Entertaining Space': 0,
        'High Speed Internet Quality': 0,
      }
    });
  }
  
      function calculateTotalValue(home) {
        // Add logic to calculate total compensation based on various components
        let total = home.baseCityValue;
        total += home.location1;
        total += home.location2;
        total += home.location3;
        total += home.location4;
        total += home.location5;
        total += home.location6;
        total += home.location7;
        total += home.location8;
        total += home.location9;
        total += home.location10;
        total += home.housedetail1;
        total += home.housedetail2;
        total += home.housedetail3;
        total += home.housedetail4;
        total += home.housedetail5;
        total += home.housedetail6;
        total += home.housedetail7;
        total += home.housedetail8;
        total += home.housedetail9;
        total += home.housedetail10;
        total += home.interior1;
        total += home.interior2;
        total += home.interior3;
        total += home.interior4;
        total += home.interior5;
        total += home.interior6;
        total += home.interior7;
        total += home.interior8;
        total += home.interior9;
        total += home.interior10;
        total += home.interior11;
        total += home.interior12;
        total += home.interior13;
        total += home.interior14;
        total += home.interior15;
        if (home.applyFactor1) {
      // Apply adjustments based on Factor 1
    }
    if (home.applyFactor2) {
      // Apply adjustments based on Factor 2
    }
  
        return total;
      }
  
      function formatCurrency(value) {
        return '$' + value.toLocaleString();
      }
  
      function calculateTotalHappiness(home) {
    // Ensure each value is treated as a number during summation
    return Object.values(home.happiness).reduce((total, value) => total + Number(value), 0);
  }
  
  function calculatePricePerSqftLot(home) {
        return home.sqftLot ? (home.askingPrice / home.sqftLot).toFixed(2) : 0;
      }
  
      function calculatePricePerSqftHouse(home) {
        return home.sqftHouse ? (home.askingPrice / home.sqftHouse).toFixed(2) : 0;
      }
  
  
      return {
        homeOffers,
        locationComponents,
        homeComponents,
        interiorComponents,
        UserPriceComponents,
        addhomeOffer,
        calculateTotalValue,
        formatCurrency,
        happinessComponents,
        calculateTotalHappiness,
        calculatePricePerSqftLot,
        calculatePricePerSqftHouse
      };
    }
  };
  </script>
  
  <style scoped>
  .home-offer-comparator {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #4A148C; /* Purple background */
    color: white; /* White text */
    padding: 20px;
    border-radius: 20px;
    margin: 20px;
  }
  
  .home-offer-comparator table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .home-offer-comparator th, td {
    border: 1px solid #6a5acd; /* RiskyPaws Purple */
    padding: 10px;
    text-align: left;
  }
  
  .home-offer-comparator th {
    background-color: #36454f; /* Charcoal */
  }
  
  .home-happiness {
    background-color: #36454f; /* Charcoal */
    border-radius: 15px;
    padding: 20px;
    margin: 10px;
    width: calc(100% - 20px); /* Full width with padding */
  }
  
  .home-happiness label {
    margin-right: 10px;
  }
  
  .home-happiness input[type="range"] {
    accent-color: #6a5acd; /* RiskyPaws Purple for slider thumb */
  }
  
  button {
    background-color: #36454f; /* Purple background */
    color: white; /* White text */
    border: none;
    border-radius: 20px; /* Rounded corners */
    padding: 10px 20px; /* Padding inside the button */
    cursor: pointer; /* Cursor style */
    transition: background-color 0.3s ease; /* Smooth transition for hover effect */
  }
  
  button:hover {
    background-color: black; /* Black background on hover */
  }
  
  </style>
  